// cleanup_convert_to_typescript_file_PAYMENT_MAPS

/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

export default createUseStyles(
  ({
    breakpoints: {
      values: { md, xs }
    },
    palette,
    palette: {
      colors: { tundora: black },
      common: { white }
    },
    spacing: { unit }
  }) => ({
    body: {
      background: palette.background
    },
    addValueField: {
      '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '& input[type="number"]': {
        '-moz-appearance': 'textfield'
      }
    },
    currencyStyles: {
      paddingTop: 0.5 * unit
    },
    header: {
      background: '#f2f2f2',
      borderBottom: '1px solid #ccc',
      borderTop: '2px solid #ccc',
      display: 'flex',
      fontSize: 12,
      justifyContent: 'space-between',
      textAlign: 'left',
      textTransform: 'uppercase'
    },
    addValueIcon: {
      paddingLeft: 10
    },
    headerCell: {
      '&:first-child': {
        marginLeft: 0
      },
      margin: [0, 60],
      width: 250
    },
    addValuePopover: {
      display: 'inline'
    },
    headerCellUpdate: {
      alignItems: 'center',
      flexDirection: 'row !important',
      justifyContent: 'flex-start !important'
    },
    cell: {
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        marginRight: 0
      },
      margin: 0,
      width: 250,
      padding: [1.875 * unit, 2.5 * unit]
    },
    optionalName: {
      '&:before': {
        content: '"Optional"',
        height: 10,
        left: 0,
        color: '#6e6e6e',
        width: 10,
        display: 'block',
        position: 'relative',
        fontSize: 10,
        top: '-3px'
      },
      position: 'relative'
    },
    amountAddValue: {
      '& .input-group': {
        zIndex: 0
      },
      paddingTop: 20
    },
    wrapper: {
      [`@media only screen and (max-width: ${md}px)`]: {
        margin: [0, 30]
      },
      margin: [0, 20 * unit],
      '&.fixed-map.update-type': {
        margin: [0, 6 * unit]
      }
    },
    dropdown: {
      marginTop: 0.5 * unit,
      '& label': {
        display: 'block',
        height: 0,
        margin: 0,
        width: 0,
        overflow: 'hidden'
      }
    },
    row: {
      background: palette.background,
      borderBottom: '1px solid #ccc',
      display: 'flex',
      justifyContent: 'space-between',
      minHeight: 115
    },
    positionField: {
      '& label': {
        marginBottom: 0
      }
    },
    updateCell: {
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        marginRight: 0
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: [2 * unit, 2.5 * unit],

      width: `${80 / 3}%`,
      '&.fixed-map': {
        width: `${80 / 4}%`
      }
    },
    updateCheckbox: {
      justifyContent: 'flex-start !important',
      paddingTop: '30px !important',
      '& [class*="checkboxIcon-"][class*="selected-"]': {
        backgroundColor: black,
        '& svg': {
          stroke: white
        }
      }
    },
    switchTransactionRowLink: {
      [`@media only screen and (max-width: ${1600}px) and (min-width: ${xs}px)`]: {
        fontSize: 12
      },
      fontSize: 15,
      paddingTop: 10,
      textAlign: 'left'
    },
    updateCheckboxCell: {
      width: '10%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: [1.875 * unit, 2.5 * unit]
    },
    transactionField: {
      '&.tableCheckbox': {
        paddingTop: '45px !important'
      },
      paddingTop: '32px !important'
    },
    tooltipText: {
      textTransform: 'none',
      fontSize: 1.875 * unit
    }
  })
);
